import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { Constantes } from '../../shared/constant/constantes';
import { HeaderComponent } from '../../shared/header/header.component';
import { MenuAlternoComponent } from '../public/menu-alterno/menu-alterno.component';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';

export class Seccion {
  public id: number = 0;
  public titulo: string = '';
  public tipo: string = '';
  public expanded: boolean = false;
  public hijo: any;
}

export class NotasFeErratas {
  public id!: number;
  public idSerie!: number;
  public tipo: string = '';
  public descripcion: string = '';
  public estado: string = '';
  public nombreAdjunto: string = '';
  public fecha!: Date;
}

@Component({
    selector: 'app-metadata-serie',
    templateUrl: './metadata-serie.component.html',
    styleUrls: ['./metadata-serie.component.css'],
    standalone: true,
    imports: [CommonModule, HeaderComponent, MenuAlternoComponent, CdkAccordionModule, MatIconModule]
    
})
export class MetadataSerieComponent implements OnInit {

  public tituloTematica: string = '';

  public idSerie: string = '';
  public idSerieNotas: string = '';
  public tipoSelected: string = '';

  private tituloTMP: string = '';

  public listaDataAccordion: Array<Seccion> = new Array();
  public constantes: Constantes = new Constantes();

  constructor(private service: VisualizadorService, private route: ActivatedRoute, private location: Location) {
  }

  ngOnInit(): void {
    const currentUrl = this.location.path();
    this.service.generaTagsHtmlSEO('Metadata de las series','Detalle de la información de las series, su fe de erratas y documentos.','metadata, detalle, serie, datos',currentUrl);

    var seriesId = this.route.snapshot.paramMap.get('idSerie')!;
    this.tipoSelected = this.route.snapshot.paramMap.get('tipo')!;
    var listaIds = seriesId.split(',');
    if (listaIds.length >= 1) {
      this.idSerie = listaIds[0];
      if (listaIds.length == 2) {
        this.idSerieNotas = listaIds[1];
      }
    }
    this.getSeccionData();
  }

  private getSeccionData() {
    var tipoIF: string = 'METADATA_SERIE';
    var tipoDM: string = 'METODOLOGIAS';
    var tipoNF: string = 'NOTAS_FE_ERRATAS';
    var selectedIF: boolean = false;
    var selectedDM: boolean = false;
    var selectedNF: boolean = false;
    switch (this.tipoSelected) {
      case 'METADATA_SERIE':
        selectedIF = true;
        break;
      case 'METODOLOGIAS':
        selectedDM = true;
        break;
      case 'NOTAS_FE_ERRATAS':
        selectedNF = true;
        break;
      default:
        break;
    }
    this.generaInformacionSerie(tipoIF, selectedIF);
    this.generaMetodologia(tipoDM, selectedDM);
    this.generaNotasFeErratas(tipoNF, selectedNF);
  }

  private gestionListaXSeccion(tipo: string, datoHijo: any) {
    this.listaDataAccordion.forEach(sec => {
      if (sec.tipo === tipo) {
        sec.hijo = datoHijo;
      }
    });
  }

  private generaInformacionSerie(tipo: string, selected: boolean) {
    let seccion: Seccion = new Seccion();
    if (this.idSerie != '') {
      seccion = {
        id: 1,
        titulo: 'Información sobre la serie',
        tipo: tipo,
        expanded: selected,
        hijo: []
      };
      this.listaDataAccordion.push(seccion);

      this.service.getInformacionBasicaSerie(this.idSerie).subscribe({
        next: (jsonWebMenu) => {
          this.tituloTMP = jsonWebMenu[0].descripcion;
          this.gestionListaXSeccion('METADATA_SERIE', jsonWebMenu);
        },
        error: (error) => {
          console.log("Error inesperado en getInformacionMenu", error);
        }
      });
    }
  }

  private generaNotasFeErratas(tipo: string, selected: boolean) {
    var listaFeDeErratas: Array<string> = new Array();
    let seccion: Seccion = new Seccion();
    if (this.idSerieNotas != '') {
      seccion = {
        id: 3,
        titulo: 'Notas aclaratorias y fe de erratas',
        tipo: tipo,
        expanded: selected,
        hijo: []
      };
      this.listaDataAccordion.push(seccion);

      this.service.getNotasFeErratas(this.idSerieNotas).subscribe({
        next: (sc: any) => {        
          //DESARROLLO PARA GENERAR LAS NOTAS
          //05-JULIO-2024 DESARROLLO PARA GENERAR LAS NOTAS  
          var feErratas = '';
          if (sc != null) {
            this.tituloTematica = this.getTitulo(this.idSerieNotas, sc);
            var notas: string = '';
            var fde = this.generaNotas(sc, notas);
            if (fde != null && fde.trim() != '') {
              feErratas = fde;
            } else {
              feErratas = sc.notas;
            }
          }else {
            this.tituloTematica = this.tituloTMP;
          }
          listaFeDeErratas.push(feErratas);
          this.gestionListaXSeccion('NOTAS_FE_ERRATAS', listaFeDeErratas);
        },
        error: (error) => {
          console.log("Error inesperado en getInformacionMenu", error);
        }
      });
    }
  }

  private generaMetodologia(tipo: string, selected: boolean) {
    var listaMetodologias: Array<NotasFeErratas> = new Array();
    let seccion: Seccion = new Seccion();
    if (this.idSerie != '') {
      seccion = {
        id: 2,
        titulo: 'Documentos metodológicos',
        tipo: tipo,
        expanded: selected,
        hijo: []
      };
      this.listaDataAccordion.push(seccion);
      this.service.consultaFeErratas(this.idSerie).subscribe({
        next: (jsonResponse) => {
          jsonResponse.forEach((element: NotasFeErratas) => {
            if (this.constantes.LISTA_METODOLOGIAS.some(tn => tn.includes(element.tipo))) {
              listaMetodologias.push(element);
            }
          });
          this.gestionListaXSeccion('METODOLOGIAS', listaMetodologias);
        },
        error: (error) => {
          console.log("Error inesperado en consultaFeErratas  ", error);
        }
      });
    }
  }

  public abrirEnlace(archivo: string) {
    if (archivo.includes('pdf') && !archivo.includes('https')) {
      this.service.consultaArchivo(archivo)
        .subscribe(dataResponse => {
          var newBlob = new Blob([dataResponse], { type: "application/pdf" });
          const data = window.URL.createObjectURL(newBlob);
          this.service.windowOpen(data, '_blank');
        });
    } else {
      this.service.windowOpen(archivo, '_blank');
    }
  }

  private generaNotas(nfe: any, listaNotas: string): string {
    if (nfe != null && nfe.notas != null && nfe.notas.length > 0) {
      nfe.notas.forEach((element: any) => {
        var n = '';
        for (let i = 0; i < nfe.nivel; i++) {
          n += ' ';
        }
        if(!listaNotas.includes(element.descripcion)){
          if (element.tipo === 'NOTA_ACLARATORIA') {
            n += '<li class="li-lista-enlace-guia"><span class="span-nota-fe-errata">Nota aclaratoria: </span>' + element.descripcion + '</li>' + '\n\n';
            listaNotas += n;
          } else {
            n += '<li class="li-lista-enlace-guia"><span class="span-nota-fe-errata">Fe de errata: </span>' + element.descripcion + '</li>' + '\n\n';
            listaNotas += n;
          }
        }
        
      });
    }
    if (nfe != null && nfe.seriesHijas != null && nfe.seriesHijas.length > 0) {
      nfe.seriesHijas.forEach((element: any) => {
        listaNotas = this.generaNotas(element, listaNotas);

      });
    }
    return listaNotas;
  }

  private getTitulo(id: string, json: any): string {
    var resultado = '';
    if (Number(id) === Number(json.idSerie)) {
      return json.nombre;
    } else {
      if (json.seriesHijas.length > 0) {
        json.seriesHijas.forEach((element: any) => {
          resultado = this.getTitulo(id, element);
        });
      } else {
        resultado = json.nombre;
      }
    }
    return resultado;
  }

}
